import { Button, Icon, Spinner } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { ACCOUNT_ARCHIVE } from 'modules/Services/types'
import { useDispatch } from 'react-redux'

export const ArchiveButton = ({
  action,
  id,
  icon,
  className = '',
  noLabel,
  ...rest
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation(['services'])
  const [processing, setProcessing] = useState(false)
  const breakpoints = useBreakpoint()

  const handleClick = useCallback(() => {
    if (processing) {
      return
    }

    setProcessing(true)

    dispatch({
      type: ACCOUNT_ARCHIVE,
      payload: { ids: [id] },
    })
  }, [setProcessing, id])

  return (
    <Button
      size={'s'}
      variant={'ghost'}
      className={className}
      onClick={handleClick}
      startIcon={
        processing ? (
          <Spinner width={24} />
        ) : (
          <Icon name={icon} color={rest.iconColor ?? 'inherit'} />
        )
      }
      noLabel={noLabel ?? breakpoints.l}
      {...rest}
    >
      {t(`services::account_list.extra_actions.${action}`)}
    </Button>
  )
}

ArchiveButton.propTypes = {
  action: PropTypes.string,
  id: PropTypes.number,
  icon: PropTypes.string,
  className: PropTypes.string,
  noLabel: PropTypes.bool,
}
